module.exports = __webpack_public_path__ + "img/img_clients13.0ad16684.jpg";